import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CreateCustOpenInvoiceNoteRequestDto } from "../../../../core/models/reports/createCustOpenInvoiceNoteRequestDto";
import { FormsModule } from "@angular/forms";
import { TableModule } from "primeng/table";
import { DrawerModule } from "primeng/drawer";

@Component({
  selector: "jni-ar-aging-details-note",
  templateUrl: "./ar-aging-details-note.component.html",
  styleUrls: ["./ar-aging-details-note.component.scss"],
  imports: [FormsModule, TableModule, DrawerModule],
})
export class ArAgingDetailsNoteComponent {
  @Input() notes = "";
  @Input() display!: boolean;
  @Input() recIdList: string[] = [];
  @Output() closeSidebar = new EventEmitter();
  @Output() displayChange = new EventEmitter<boolean>();
  @Output() saveNotesEvent =
    new EventEmitter<CreateCustOpenInvoiceNoteRequestDto>();

  onHide() {
    this.displayChange.emit(false);
    this.closeSidebarModel();
  }

  closeSidebarModel() {
    this.closeSidebar.emit();
  }
  saveNotes() {
    const request = {
      InvoiceRecIdList: this.recIdList,
      Notes: this.notes,
    } as CreateCustOpenInvoiceNoteRequestDto;

    this.saveNotesEvent.emit(request);
  }
}
